import { Partner } from './store'
import { AppState } from '../../store'
import { Dispatch } from 'react'
import { PartnerAction, SELECT_PARTNER } from './reducers'

export function selectPartner(partner: Partner) {
  return function (state: AppState, dispatch: Dispatch<PartnerAction>) {
    dispatch({
      type: SELECT_PARTNER,
      partner
    })
  }
}
